// v292b-hetzner-anchors
import React from 'react';
import { reportError } from '../utils/errorReporter';

// Fehler, die von Browser-Extensions oder In-App-Browsern verursacht werden
// und nicht durch unseren Code fixbar sind. Diese silent recover-en statt Crash-Screen.
const EXTENSION_ERR_RE = /removeChild.*is not a child of this node|insertBefore.*is not a child of this node|The object can not be found here|cashbackReminder|enableDidUserTypeOnKeyboardLogging|Java object is gone|iabjs:\/\//i;

// v292b: ChunkLoadError = neuer Deploy, alter Chunk-Hash im Browser gecacht.
// Einmalig automatisch neu laden -> holt neuen index.html mit korrekten Chunk-Refs.
const CHUNK_ERR_RE = /ChunkLoadError|Loading chunk \d+ failed|Loading CSS chunk \d+ failed|Failed to fetch dynamically imported module/i;
const RELOAD_FLAG = 'trxl_chunk_reload_ts';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(err) {
    const msg = (err && err.message) || 'Ein Fehler ist aufgetreten';
    if (EXTENSION_ERR_RE.test(msg)) {
      return { hasError: false, message: '' };
    }
    if (CHUNK_ERR_RE.test(msg)) {
      return { hasError: true, message: 'Neue Version erkannt – lade neu…' };
    }
    return { hasError: true, message: msg };
  }

  componentDidCatch(err, info) {
    const msg = err?.message || 'React error';
    if (EXTENSION_ERR_RE.test(msg)) return;

    if (CHUNK_ERR_RE.test(msg)) {
      try {
        const last = parseInt(sessionStorage.getItem(RELOAD_FLAG) || '0', 10);
        const now = Date.now();
        if (now - last > 60000) {
          sessionStorage.setItem(RELOAD_FLAG, String(now));
          const sep = window.location.search ? '&' : '?';
          window.location.replace(window.location.pathname + window.location.search + sep + '_r=' + now + window.location.hash);
          return;
        }
      } catch (_e) { /* sessionStorage disabled */ }
      try {
        reportError(msg, {
          severity: 'warning',
          context: `ChunkLoadError @ ${window.location.pathname}`,
          stack: err?.stack || '',
        });
      } catch (_e) { /* silent */ }
      return;
    }

    try {
      reportError(msg, {
        severity: 'error',
        context: `ErrorBoundary @ ${window.location.pathname}`,
        stack: (err?.stack || '') + '\n\n' + (info?.componentStack || ''),
      });
    } catch (_e) { /* silent */ }
  }

  handleReset = () => { this.setState({ hasError: false, message: '' }); window.location.reload(); };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" style={{
          minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '2rem', textAlign: 'center', background: '#0a0a0a', color: '#fff',
        }}>
          <div style={{ maxWidth: 480 }}>
            <h1 style={{ color: '#EC2229', marginBottom: '1rem' }}>Etwas ist schiefgelaufen</h1>
            <p style={{ color: '#9ca3af', marginBottom: '1.25rem' }}>
              Wir haben den Fehler automatisch protokolliert und uns informiert.
              Bitte versuche es erneut oder lade die Seite neu.
            </p>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button onClick={this.handleReset}
                style={{ padding: '10px 22px', background: '#EC2229', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 700 }}>
                Seite neu laden
              </button>
              <a href="/" style={{ padding: '10px 22px', background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', color: '#fff', borderRadius: 6, textDecoration: 'none' }}>
                Zur Startseite
              </a>
            </div>
            <details style={{ marginTop: 16, textAlign: 'left', fontSize: 12, color: '#666' }}>
              <summary style={{ cursor: 'pointer' }}>Details</summary>
              <pre style={{ marginTop: 6, whiteSpace: 'pre-wrap' }}>{this.state.message}</pre>
            </details>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
